import React from "react";
import { Container, Button, Row, Col } from "reactstrap";

function WhyAttend() {
  // const [isOpen, setIsOpen] = React.useState(false);

  // const toggle = i => setIsOpen(i);
  console.log(waContent);
  return (
    <div
      style={{
        backgroundColor: "transparent",
      }}
      className="section p-5"
      data-parallax={true}
    >
      <Container>
        <Row>
          <Col lg={12}>
            <h2 className="text-700 mb-4 text-white text-uppercase">Why Attend</h2>
            <h5 className="text-white text-400">
              Step into the future of finance at Finnovex Qatar 2026, where 200+ industry pioneers,
              disruptors, and visionaries converge to shape the next era of banking and financial
              innovation. This exclusive summit is your gateway to unlocking transformative
              strategies, forging high-impact partnerships, and staying ahead in an ever-evolving
              digital landscape.
              <br />
              <br />
            </h5>
          </Col>
        </Row>
        <Row className="justify-content-center">
          {waContent.map((data, index) => (
            <Col lg={6} key={index} className="stat-div border">
              <div className=" p-3" style={{ minHeight: "130px" }}>
                <h4 className="text-700 mt-0 text-white">{data.title}</h4>
                <br />
                <h5 className="text-400 mt-0 text-white">{data.description}</h5>
              </div>
            </Col>
          ))}
        </Row>
        <br />
        <br />
        <Row className="justify-content-center">
          <Button className="p-2 rounded-0" color="primary" size="lg" href="/register">
            <h5 className="m-0 text-400 text-white">Register Now</h5>
          </Button>
        </Row>
      </Container>
    </div>
  );
}
export default WhyAttend;

const waContent = [
  {
    title: "Connect with the Power Players",
    description:
      "Network with top decision-makers, thought leaders, and innovators redefining the financial sector. These are more than connections—they are game-changing alliances that can accelerate your business growth.",
  },
  {
    title: "Build Strategic Partnerships That Matter",
    description: `Whether it's fintech collaborations, banking innovations, or regulatory insights, Finnovex is where powerful, lasting partnerships are born to fuel your success.`,
  },
  {
    title: "Stay at the Forefront of Financial Evolution",
    description:
      "From AI-driven banking to digital payments and regulatory tech, gain exclusive insights into groundbreaking trends that are shaping the future of finance in the region and beyond.",
  },
  {
    title: "Gain Actionable Insights for Immediate Impact:",
    description:
      "Walk away with real-world strategies, proven frameworks, and cutting-edge solutions that can be implemented immediately to drive tangible results for your organization.",
  },
  {
    title: "Elite Networking, Tailored for You:",
    description:
      "Take advantage of curated networking opportunities, exclusive executive lounges, and interactive discussions designed to foster meaningful conversations with key industry stakeholders.",
  },
];
